import React, { useEffect, useState } from 'react'
import CustomModal from 'components/modals/CustomModal'

const InternetConnection = ({ children }) => {
  const [isOnline, setIsOnline] = useState(true);

  const onlineListener = () => setIsOnline(true);
  const offlineListener = () => setIsOnline(false);

  useEffect(() => {
    window.addEventListener('online', onlineListener);
    window.addEventListener('offline', offlineListener);

    return () => {
      window.removeEventListener('online', onlineListener);
      window.removeEventListener('offline', offlineListener);
    }
  }, [])

  return (
    <>
      {children}
      <CustomModal show={!isOnline} closeButton={false}>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h2>🔌 Oops! You're Offline</h2>
          <p>It looks like you've lost your internet connection.
            Please check your network and try again.</p>
        </div>
      </CustomModal>

    </>
  )
}

export default InternetConnection;